import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'app/shared/services/authentification/authentification.service';
import { DataService } from 'app/shared/services/data/data.service';
import { UserService } from 'app/shared/services/user/user.service';

@Component({
  selector: 'app-unlink-licence',
  templateUrl: './unlink-licence.component.html',
  styleUrls: ['./unlink-licence.component.scss']
})
export class UnlinkLicenceComponent implements OnInit {

  constructor(
    private router: Router,
    private dataService: DataService,
    private userService: UserService,
    private authService: AuthenticationService
  ) { }

  ngOnInit(): void {
  }

  dissociate(): void {
    this.userService.unLinkMyAccount().subscribe(() => {
      this.dataService.userIsLink.next(false);
      this.authService.refreshToken().subscribe(() => {
        this.dataService.unlink.next(true);
        if (localStorage.getItem('url') === 'login') {
          this.router.navigate(['/licence']);
        }

        this.getMenu();
      }, error => {
        this.dataService.userIsLink.next(false);
        this.dataService.unlink.next(true);
        if (localStorage.getItem('url') === 'login') {
          this.router.navigate(['/licence']);
        }
      });
    });

  }

  private getMenu(): void {
    this.userService.getMenuUser().subscribe(res => {
      this.dataService.menu.next(res);
    });
  }

}
